let Dynamic_data = {};
// let check_Url =
//   window.location.hostname === "www.rightcause.net" ? false : true;
let check_Url = false;
console.log("??=>", window.location.hostname);
console.log("check_Url=> ", check_Url);

if (check_Url) {
  Dynamic_data = {
    Site_key: "6Lc5OZYiAAAAAM1qgHr_vuRCcAvYq2deIAia2Xcp",
    cd_Dimensions_url: "https://analytics-au.clickdimensions.com/forms/h/awQ6nqabBkmFFJKXdexVcA",
    cd_Dimensions_NewslwtterUrl:"https://analytics-au.clickdimensions.com/forms/h/aO3SkcY5wUCAQX2pF6NPnA",
    Apis_Url: {
      SubmitForm: "https://beyondintranet.beyondkeystage.com:8080/api/submit-rightcause-form/",
      SubmitNewsLetterForm: "https://beyondintranet.beyondkeystage.com:8080/api/submit-rightcause-newsletterform/",
      call_cd_Dimensions: false
    },
  };
} else {
  Dynamic_data = {
    Site_key: "6LefPZYiAAAAAMpS9UW6I_YNgXkvTDq-0nbMBw1h",
    cd_Dimensions_url: "https://analytics-au.clickdimensions.com/forms/h/awQ6nqabBkmFFJKXdexVcA",
    cd_Dimensions_NewslwtterUrl:"https://analytics-au.clickdimensions.com/forms/h/aO3SkcY5wUCAQX2pF6NPnA",
    Apis_Url: {
      SubmitForm: "https://www.beyondintranet.com/api/submit-rightcause-form/",
      SubmitNewsLetterForm: "https://www.beyondintranet.com/api/submit-rightcause-newsletterform/",
    },
    call_cd_Dimensions: false
  };
}

export default Dynamic_data;
